import { Component, Input } from '@angular/core';

import { ComboboxCnpjComponent } from '../combobox-cnpj/combobox-cnpj.component';
import { CnpjService } from '../../core/services/common/cnpj.service';

@Component({
    selector: 'app-pop-up-cnpj',
    imports: [ComboboxCnpjComponent],
    templateUrl: './pop-up-cnpj.component.html',
    styleUrl: './pop-up-cnpj.component.scss'
})
export class PopUpCnpjComponent {
  @Input() isGlobalCnpj: boolean = false;

  constructor(
    private cnpjService: CnpjService
  ) { }

  public cleanCnpj(): void {
    this.cnpjService.setSelectedCnpj('');
    localStorage.removeItem('CNPJ');
    localStorage.removeItem('CNPJ_NAME');
  }

  public closePopUp(): void {
    this.cnpjService.showCnpjPopup(false);
  }

  get shouldShowCnpjPopup(): boolean {
    return this.cnpjService.isCnpjPopupVisible;
  }
}
